/* eslint-disable */

// dont load polyfills, these should be loaded by the app that loads this

import Auth from 'bfu-auth-client/src/auth/Auth.js';

window["BlueflagAuth"] = new Auth();
